import React from "react";

import { Stack } from "@mui/material";
import classnames from "classnames";
import { FiClock } from "react-icons/fi";
import { IoIosAddCircleOutline } from "react-icons/io";
import { MdOutlineCalendarToday } from "react-icons/md";

import Checkbox from "../../../../../../../components/Form/Checkbox";
import useStyles from "./styles";

export type Date = {
  id?: number;
  formattedDate: string;
  formattedHour?: string;
  value: string;
  checked: boolean;
};

type Props = {
  type?: string;
  dates?: Date[];
  onChangeDates?: (dates: Date[]) => void;
  onAddTaskDates?: (dates: Date[]) => void;
  hideAddDatesSelected?: boolean;
};

const TaskDate = (props: Props) => {
  const { type, dates, onChangeDates, onAddTaskDates, hideAddDatesSelected } = props;

  const classes = useStyles();

  const onChangeCheckbox = (checked: boolean, index: number) => {
    const datesSelectedUpdated = [...(dates || [])];

    datesSelectedUpdated[index] = {
      ...datesSelectedUpdated[index],
      checked,
    };
    if (onChangeDates) onChangeDates(datesSelectedUpdated);
  };

  const renderCheckboxDate = (checked: boolean, index: number) => {
    if (hideAddDatesSelected !== true) {
      return (
        <Checkbox
          control={{
            checked,
            onChange: (event, checked) => onChangeCheckbox(checked, index),
            className: classes.checkbox,
            size: "small",
            "data-cy": `checkTaskDate${type}${index}`,
          }}
        />
      );
    }
  };

  const renderFormattedHour = (date: Date) => {
    if (date?.formattedHour) {
      return (
        <Stack direction="row" spacing={1}>
          <FiClock color="#93A9BD" />
          <span className={classes.dateTitle}>{date?.formattedHour}</span>
        </Stack>
      );
    }

    return null;
  };

  const renderDates = () => {
    if (dates && dates.length > 0) {
      return dates.map((date, index) => {
        return (
          <Stack key={date.formattedDate} direction="row" alignItems="center" spacing={1}>
            {renderCheckboxDate(date?.checked, index)}
            <Stack direction="row" alignItems="center" spacing={2}>
              <Stack direction="row" spacing={1}>
                <MdOutlineCalendarToday color="#93A9BD" />
                <span className={classes.dateTitle}>{date.formattedDate}</span>
              </Stack>
              {renderFormattedHour(date)}
            </Stack>
          </Stack>
        );
      });
    }

    return null;
  };

  const renderAddSelectedDates = () => {
    if (hideAddDatesSelected !== true) {
      return (
        <IoIosAddCircleOutline
          onClick={() => {
            if (dates && dates?.length > 0 && onAddTaskDates) {
              onAddTaskDates(dates);
            }
          }}
          color={dates && dates?.find((date) => date?.checked === true) ? "#308CDB" : "#9CA6AF"}
          fontSize="18px"
          data-cy={`buttonTaskDate${type}`}
          className={classnames("MuiSvgIcon-root", classes.button)}
        />
      );
    }

    return null;
  };

  const renderContent = () => {
    if (type && dates && dates.length > 0) {
      return (
        <div>
          <Stack direction="column" spacing={1}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <span className={classes.title} data-cy="headerComponentTaskType">
                {type}
              </span>
              {renderAddSelectedDates()}
            </Stack>
            {renderDates()}
          </Stack>
        </div>
      );
    }

    return null;
  };

  return renderContent();
};

export { TaskDate as TaskDateComponent };

export default TaskDate;
